import { matchPath, useLocation } from 'react-router-dom'
import {
  AdGroupRouteUrl,
  CampaignProgrammaticRouteUrl,
  CampaignRouteUrl,
  InventoryRouteUrl,
  PositionRouteUrl,
  WebsiteRouteUrl,
} from '../../pages/routeParams'

export interface SidebarActiveRouteParams {
  adgroupId?: string
  campaignId?: string
  campaignProgrammaticId?: string
  inventoryId?: string
  positionId?: string
  siteId?: string
}

const SIDEBAR_ROUTE_PATTERNS = [
  `${CampaignRouteUrl}/*`,
  `${CampaignProgrammaticRouteUrl}/*`,
  `${WebsiteRouteUrl}/*`,
  `${AdGroupRouteUrl}/*`,
  `${InventoryRouteUrl}/*`,
  `${PositionRouteUrl}/*`,
] as const

export const parseSidebarActiveRouteParams = (pathname: string): SidebarActiveRouteParams => {
  for (const pattern of SIDEBAR_ROUTE_PATTERNS) {
    const match = matchPath({ path: pattern, end: false }, pathname)
    if (!match?.params) continue

    return {
      siteId: match.params.siteId,
      campaignId: match.params.campaignId,
      campaignProgrammaticId: match.params.campaignProgrammaticId,
      positionId: match.params.positionId,
      adgroupId: match.params.adgroupId,
      inventoryId: match.params.inventoryId,
    }
  }

  return {}
}

export const useSidebarActiveRouteParams = (): SidebarActiveRouteParams => {
  const { pathname } = useLocation()
  return parseSidebarActiveRouteParams(pathname)
}
